import { z } from 'zod';
import { TabelaPrecoExcecaoTipoPreco, TabelaPrecoTipoVariacao } from './enum';
import { TabelaPrecoProdutoPacoteBarraPartialSchema } from './TabelaPrecoProdutoPacoteBarraPartial';
import { TabelaPrecoProdutoPartialSchema } from './TabelaPrecoProdutoPartial';

const TabelaPrecoExcecaoSchema = z.object({
    produto: TabelaPrecoProdutoPartialSchema,
    produto_pacote_barra: TabelaPrecoProdutoPacoteBarraPartialSchema.nullable(),
    tpe_idpk: z.number(),
    tpe_preco: z.number(),
    tpe_produto_idpk: z.number(),
    tpe_produto_pacote_barra_idpk: z.number().nullable(),
    tpe_tipo_preco: z.enum(TabelaPrecoExcecaoTipoPreco),
    tpe_ultima_alteracao: z.string().nullable(),
});

export const TabelaPrecoSchema = z.object({
    tabela_preco_excecao: TabelaPrecoExcecaoSchema.array().nullable(),
    tap_descricao: z.string(),
    tap_empresa_idpk: z.number(),
    tap_entregador_tabela_comissao_idpk: z.number().nullable(),
    tap_idpk: z.number(),
    tap_percentual: z.number(),
    tap_tabela_comissao_idpk: z.number().nullable(),
    tap_tipo_variacao: z.enum(TabelaPrecoTipoVariacao),
    tap_ultima_alteracao: z.string().nullable(),
});

export type TabelaPreco = z.infer<typeof TabelaPrecoSchema>;
